import { gql } from '@apollo/client'

export const Query = gql`
  query EditAccommodationRoomType($companyId: ID!, $accommodationId: ID!, $accommodationRoomTypeId: ID!) {
    accommodations(companyId: $companyId, filters: { idEq: $accommodationId }, first: 1) {
      nodes {
        id
        accommodationRoomTypes(filters: { idEq: $accommodationRoomTypeId }, first: 1) {
          nodes {
            id
            capacity
            layout
            name
            notes
          }
        }
      }
    }
  }
`
